<template>
    <div class="introduce">
        <div class="artic">
            <div v-if="languageType == 0" class="text" v-html="introduce"></div>
            <div v-else class="text" v-html="enIntroduce"></div>
            
            <div class="pic">
                <img :src="picUrl"/>
                
            </div>
           
        </div>
        <div class="honors">
            <div class="title">
                    <p>企业荣誉</p>
                    <p>Company Honors</p>
            </div>
            <div class="slide">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <!-- :style="{backgroundImage:'url('+item+')'}" -->
                        <div class="swiper-slide" :style="{backgroundImage:'url('+item+')'}" v-for="(item,index) in honorsList" :key="index" >
                        </div>
                    </div>
                    <!-- Add Pagination -->
                    <div class="swiper-button-prev"></div>
                    <div class="swiper-button-next"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props:['languageType'],
    data () {
        return {
            dataList:[],
            introduce:'',
            enIntroduce:'',
            picUrl:'',
            honorsList:[]
        }
    },
    created () {
        this.getDataList()
    },
    mounted () {

        setTimeout(function () {
            var swiper = new Swiper('.swiper-container', {
            slidesPerView: 'auto',
            spaceBetween: 30,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
        },500)
       
    },
    methods:{
        getDataList () {
            this.$http({
                url: this.$http.adornUrl('/web/company/list'),
                method: 'post',
                data: {
                    'page': '1',
                    'limit': '999',
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    this.introduce = data.page[0].introduce
                    this.enIntroduce = data.page[0].enIntroduce
                    this.picUrl = data.page[0].picUrl
                    let arr =  data.page[0].pics.split(',')
                    let temp = []
                    arr.forEach(item => {
                        temp.push(item)
                    })
                    this.honorsList = temp
                } else {
                    this.bannerList = []
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
    .introduce {
        margin: 0px 80px 90px 80px;
        padding-top: 40px;

        .artic {
            overflow: hidden;
            border-bottom: 2px solid #aeaeae;
            text-align: left;
            width: 1060px;
            word-break: break-all;
            .text {
                float: left;
                width: 400px;
                // height: 326px;
                margin-bottom: 65px;
                overflow: hidden;
                text-align: left;
                p {
                    text-align: left;
                    line-height: 5px;
                }
            }
            .pic {
                float: right;
                width: 579px;
                height: 326px;
                background-color: blanchedalmond;
                img {
                   width: 579px;
                    height: 326px; 
                }
            }
        }
        .honors {
            padding-bottom: 90px;
            .title {
                    margin: 0 auto;
                    position: relative;
                    margin-top: 55px;
                    margin-bottom: 60px;
                    p{
                        color: #e21711;
                        text-align: center;
                    }
                    p:first-child {
                        font-size: 30px;
                    }
                    p:last-child {
                        font-size: 20px;
                        margin-top: 6px;
                    }
            }
            .title::before {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 6px;
                        height: 32px;
                        top:50%;
                        margin-top: -16px;
                        left: 277px;
                        background-color: #e21711;
            }
            .title::after {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 6px;
                        height: 32px;
                        top:50%;
                        margin-top: -16px;
                        right: 277px;
                        background-color: #e21711;
            }
            .slide {
                width: 890px;
                margin: 0 auto;
                overflow: hidden;
                .swiper-container {
                     width: 890px;
                    height: 150px;
                }
                .swiper-slide {
                    text-align: center;
                    font-size: 18px;
                    background: #fff;
                    height: 150px;
                    width: 250px;
                    margin-right: 15px;
                    background-size: cover;
                    background-position: center;
                    img {
                        height: 150px;
                        width: 250px;
                    }
                }
                .swiper-button-prev {
                    // left: 0px;
                    background-color:rgba(0, 0, 0, 0.2);
                }
                .swiper-button-next {
                    // left: 0px;
                    background-color:rgba(0, 0, 0, 0.2);
                }
                .swiper-button-prev:after {
                    color: #e21711;
                    
                }
                .swiper-button-next:after {
                    color: #e21711;
                }
            }
        }
    }
</style>
<style>
    .introduce .ql-container {
        height: 260px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Introduce.vue